import { render } from "./Cart.vue?vue&type=template&id=15bd09ae"
import script from "./Cart.vue?vue&type=script&lang=js"
export * from "./Cart.vue?vue&type=script&lang=js"
script.render = render

export default script